import React from "react";
import { useTranslation } from "react-i18next";

const VendingList = (props) => {
  const { t } = useTranslation();
  return (
    <ul className="list-unstyled list-wrapper" style={{minHeight: '350px'}}>
      {props?.storesList?.length > 0 &&
        props?.storesList.map(
          (store) =>
          (
            <li
              key={store?.storeId}
              className="cursor"
              onClick={() =>
                props?.getLetLongObj(store?.latitude, store?.longitude)
              }
            >
              <div className="map-detail-wrapper d-flex flex-wrap">
                <div className="flex-1">
                  <div className="store-name">{store?.name}</div>
                  <div className="store-address">
                    {" "}
                    {t("user.searchList.address")} :{" "}
                    <span className="font-600">
                      {store?.storeDisplayAddress && (
                        <span>{store?.storeDisplayAddress} </span>
                      )}
                    </span>
                  </div>
                  <div className="store-address">
                    {" "}
                    {t("user.searchList.notes")} : <span className="font-600">{store?.notes}</span>
                  </div>
                  <div
                    className="store-direction"
                    onClick={(ev) => props?.setMapDirection(ev, store)}
                  >
                    {t("user.searchList.directions")}
                  </div>
                </div>

                <div className="store-distance">{store?.distance} {t("user.dashboard.distanceUnit")}</div>
              </div>
            </li>
          )
        )}
      {/* <li style={{ height: "70px" }}></li> */}
    </ul>
  );
};

export default VendingList;
